import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import importDialog from './import.dialog.vue'
import SiteSearchGroup from '../../../../components/search-group'
import section from '../../../../api/section'
import journal from '@/api/journal'
const columns = [
  {
    title: '',
    enTitle: 'Classification Name',
    width: 200,
    dataIndex: 'name',
  },
  {
    title: '',
    enTitle: 'Descirption',
    width: 400,
    dataIndex: 'content',
  },
  {
    title: '',
    enTitle: 'Journal',
    width: 100,
    dataIndex: 'journalName',
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 170,
    dataIndex: 'updateTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    Add,
    importDialog,
    SiteSearchGroup,
  },
  data() {
    return {
      columns,
      isVisable: false,
      isVisableImport: false,
      hasSection: '',
      openSection: '',
      dataSource: [],
      params: {
        released: '',
      },
      displaySection: false,
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser',
    }),
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
        this.sectionStatus()
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    async getList() {
      if (!this.journalId) {
        return
      }
      const data = Object.assign(this.params, { journalId: this.journalId })
      this.dataSource = await section.getAll(data)
    },
    async sectionStatus() {
      let data = { journalId: this.journalId }
      let res = await journal.display(data)
      this.displaySection = res.displaySection
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    imp() {
      this.isVisableImport = true
    },
    add(val) {
      this.hasSection = val && val.id
      this.isVisable = true
    },
    edit(val) {
      this.hasSection = val && val.parentId
      this.$refs['journal-website-section-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await section.release(id, !released, { version })
      let content = 'This Section has been published!'
      if (released) {
        content = 'This Section has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content,
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this section?',
        content:
          'Please be aware of once this section is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        await section.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Section has been deleted!',
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await section.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisableImport = false
      this.isVisable = false
    },
    cancel() {
      this.isVisableImport = false
      this.isVisable = false
    },
    handleClear() {
      this.params = { name: '' }
      this.getList()
    },
    selectSection(id) {
      if (this.openSection === id) {
        this.openSection = ''
      } else {
        this.openSection = id
      }
    },
    async showSection(val) {
      this.displaySection = val
      let data = {
        journalId: this.journalId,
        display: this.displaySection,
        type: 'SECTION',
      }
      let res = await journal.disEdit(data)
      if (!this.displaySection) {
        this.$message.success({
          title: 'Success',
          content: 'Now the Sections are no longer displayed！',
        })
      } else {
        this.$message.success({
          title: 'Success',
          content: 'Now the Sections is back on display！',
        })
      }

      this.displaySection = res.displaySection
      this.sectionStatus()
    },
  },
}
